import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

const YesNoPopup = (props) => {
  const {
    message,
    yesHandler,    
    setPopUp,
    popUp,
    setClosedFaxPrompt
  } = props;

  const handleYes = () => {
    yesHandler();
    setClosedFaxPrompt(true);
    setPopUp(false);

  };

  const handleNo = () => {
    setClosedFaxPrompt(true);
    setPopUp(false);
  };

  return (
    <Dialog fullWidth={true} maxWidth={'xs'} open={popUp}>
      <DialogContent dividers>
        <Typography variant='h6'>{message}</Typography>
      </DialogContent>
      <DialogActions>
        <Button variant='contained' onClick={handleYes}>
          Yes
        </Button>
        <Button variant='contained' onClick={handleNo}>
          No
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default YesNoPopup;
